import { useState, useEffect } from 'react';
import { useAuthContext } from 'components/special/oAuthProvider';
import { useLocale } from 'components/special/LanguageProvider';


const myCustomMenu = [
  {
    text : "Stillingar",
    url : "/admin/settings",
    role : ["3002"],
    // subscriber : ["4307"]
  },
  {
    text : "Innheimtuþóknun",
    url : "/admin/collectionfees",
    role : ["3002"]
  },
  {
    text : "Færslulyklar",
    url : "/admin/transactionkeys",
    role : ["3002"]    
  },
  {
    text : "Færslulyklahópar",
    url : "/admin/transactiongroups",
    role : ["3002"]
  },
  {
    text : "Fastur kostnaður",
    url : "/admin/actioncosts",
    role : ["3002"]
  },
  {
    text : "Forsendutöflur",
    url : "/admin/tabletypes",
    role : ["3002"]    
  },
  {
    text : "Kröfu tegundir",    
    url : "/admin/claimtypes",
    role : ["3002"]
  },
  {
    text : "Héraðsdómar",
    url : "/admin/courts"    
  },
  {
    text : "Sýslumenn",    
    url : "/admin/magistrates"
  },
  {
    text : "Samningar",
    url : "/admin/agreements",
    role : ["3002"]
  },
  {
    text : "Merkingar",
    url : "/admin/labels",
    role : ["3002"]
  },
  {
    text : "Bréfa umsýsla",    
    url : "/admin/text-changes",
    role : ["3002"]
  },
  {
    text : "Aðgerðar textar",    
    url : "/admin/actiontexts",
    role : ["3002"]
  },
  {
    text : "Aðgerðar textar (dagatal)",    
    url : "/admin/actiontexts/diary",
    role : ["3002"]
  }
]

const exportProduct = [
  {
    text : "Skilagreinar",    
    url : "/admin/exports/return"    
  },
  {
    text : "Skilagreinar tímabil",    
    url : "/admin/exports/returnterm"    
  },
  {
    text : "Sundurliðun uppgjöra tímabil",    
    url : "/admin/exports/returnsumterm"    
  },
  {
    text : "Útlagður kostnaður",    
    url : "/admin/exports/outlaidcost"    
  },
  {
    text : "Staða á útlagðum kostnaði",    
    url : "/admin/exports/outlaidcoststatus"    
  },
  {
    text : "Uppgerð mál á tímabili",    
    url : "/admin/exports/settledclaims",
    subscriber : ["4307","3622"]    
  }
]

const importProduct = [
  {
    text : "Lín skrá",
    url : "/admin/imports/lin",
    role : ["3002"],
    subscriber : ["4307", "9618"]
  },
  {
    text : "Heimavellir skrá",
    url : "/admin/imports/heimavellir",
    role : ["3002"],
    subscriber : ["4307", "9897"]
  }

]

const otherProduct = [
  {
    text : "Aðgerðir - Jobs",    
    url : "/admin/jobs/commands",
    role : ["3002"],
    subscriber : ["4307"]
  }, 
  {
    text : "Cache",    
    url : "/admin/cache",
    role : ["3002"],
    subscriber : ["4307"]
  }, 
  {
    text : "Reiknivél",    
    url : "/calculator",
    role : ["3002"]
  },  
  {
    text : "Vanskilaskrá",    
    url : "/admin/defaultdebtorregistryoverivew",
    role : ["3002"],
    subscriber : ["4307"]
  }, 
  {
    text : "Demo",    
    url : "/demo",
    subscriber : ["4307"]
  }  
]


export default () => {
  const [products, setProducts] = useState([]);
  
  const { user, isAuthenticated } = useAuthContext();
  const { t } = useLocale();

  
  const isAuthorizedForSubscriber = (user, item) =>{
    if (item.subscriber && item.subscriber.length > 0){
      if (item.subscriber.includes(user.s_id)){
        return item;
      }
      return null;
    }
    return item;
  }

  const isAuthorized = (user, item) =>{
    if (item.role && item.role.length > 0){
      //Check if the role is with the user.          
      for (let j = 0; j < item.role.length; j++) {
        const itemRole = item.role[j];
        if (user.role.includes(itemRole)){            
          return isAuthorizedForSubscriber(user, item);            
        }
      }
      return null;
    }
    return isAuthorizedForSubscriber(user, item);        
  }

  const authorizeList = (user, menuList) =>{
    let list = [];        
    menuList.forEach(item => {
      item.text = t(item.text);
      if (isAuthenticated){
        let menuItem = isAuthorized(user, item);
        if (menuItem != null){
          list.push(menuItem);
        }
      }
    });
    return list;
  }


  useEffect(() => {           
    //Handle access control in display
    setProducts([
      { title: t("Umsýsla"), items : authorizeList(user,myCustomMenu) },
      { title: t("Skýrslur"), items : authorizeList(user,exportProduct) },
      { title: t("Inntak"), items : authorizeList(user,importProduct) },
      { title: t("Annað"), items : authorizeList(user,otherProduct) }]);
  }, []);

  return products;
};
